/* Iraci Theme JS — minimal */
(function(){
  'use strict';

  // Mobile menu toggle
  var toggle = document.querySelector('.iraci-header-toggle');
  var nav = document.querySelector('.iraci-nav');
  if(toggle && nav){
    toggle.addEventListener('click', function(){
      var expanded = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', expanded);
      if(expanded){
        nav.style.cssText = 'display:flex;position:fixed;top:72px;left:0;right:0;background:var(--iraci-bg-warm);flex-direction:column;padding:24px 5vw;gap:18px;border-bottom:1px solid var(--iraci-border);z-index:199;box-shadow:var(--iraci-shadow)';
      } else {
        nav.style.cssText = '';
      }
    });
    // Close on nav link click
    nav.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){
        if(nav.classList.contains('is-open')){
          nav.classList.remove('is-open');
          nav.style.cssText = '';
          toggle.setAttribute('aria-expanded','false');
        }
      });
    });
  }

  // Smooth pill scroll active state
  var pills = document.querySelectorAll('.iraci-pill[href^="#"]');
  pills.forEach(function(p){
    p.addEventListener('click', function(){
      pills.forEach(function(x){ x.classList.remove('is-active'); });
      p.classList.add('is-active');
    });
  });

  // FAQ — close others when one opens
  var faqs = document.querySelectorAll('.iraci-faq-item');
  faqs.forEach(function(item){
    item.addEventListener('toggle', function(){
      if(item.open){
        faqs.forEach(function(other){
          if(other !== item) other.removeAttribute('open');
        });
      }
    });
  });

  // Lazy reveal on scroll (subtle fade)
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.iraci-product-card, .iraci-gama-card, .iraci-step, .iraci-dif, .iraci-stat').forEach(function(el){
      el.style.cssText += ';opacity:0;transform:translateY(20px);transition:opacity .6s ease, transform .6s ease';
      io.observe(el);
    });
  }
})();
